module.exports = __webpack_public_path__ + "img/google_icon.b7727941.svg";